import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import { ArrowUpRight } from "lucide-react";

export function LandingFinalCta({ onDemo }) {
  return (
    <section id="contact" className="py-24 bg-zinc-950 text-zinc-100">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div className="text-[11px] uppercase tracking-[0.22em] text-emerald-300/80">Final call</div>
        <h2 className="font-display font-black tracking-tight text-4xl lg:text-6xl mt-3">Join the Hospitality<br />Intelligence Network</h2>
        <p className="mt-4 text-zinc-300 max-w-2xl mx-auto">
          Help create a safer, smarter, and more informed hospitality ecosystem. <strong className="text-white">Know Ahead.</strong>
        </p>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <Button onClick={onDemo} size="lg" variant="outline" className="rounded-full border-zinc-700 bg-transparent text-zinc-100 hover:bg-zinc-900 hover:text-white" data-testid="final-demo-btn">
            Request Demo
          </Button>
          <a href={`${process.env.REACT_APP_APP_URL || ""}/register`} target="_blank" rel="noopener noreferrer">
            <Button size="lg" className="rounded-full" data-testid="final-join-btn">
              Join GuestIntel <ArrowUpRight className="w-4 h-4 ml-1" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}

export function LandingFooter() {
  return (
    <footer className="bg-stone-100 text-stone-700 text-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-4 gap-10">
        <div>
          <Logo size="md" />
          <p className="mt-3 max-w-xs text-stone-600">Verified incident intelligence for hospitality. Know ahead. Stay prepared.</p>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-stone-500 mb-4">Product</div>
          <ul className="space-y-2">
            <li><a href="/#how" className="hover:text-stone-950">How it works</a></li>
            <li><a href="/#categories" className="hover:text-stone-950">Intel categories</a></li>
            <li><a href="/#pricing" className="hover:text-stone-950">Pricing</a></li>
            <li><a href="/#integrations" className="hover:text-stone-950">Integrations</a></li>
            <li><Link to="/about" className="hover:text-stone-950" data-testid="footer-about">About us</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-stone-500 mb-4">Compliance</div>
          <ul className="space-y-2">
            <li><Link to="/trust" className="hover:text-stone-950" data-testid="footer-trust">Trust Center</Link></li>
            <li><Link to="/privacy" className="hover:text-stone-950" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-stone-950" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/incident-review" className="hover:text-stone-950" data-testid="footer-incident-review">Incident Review Policy</Link></li>
            <li><Link to="/dispute-resolution" className="hover:text-stone-950" data-testid="footer-dispute">Dispute Resolution Policy</Link></li>
            <li><Link to="/data-retention" className="hover:text-stone-950" data-testid="footer-retention">Data Retention Policy</Link></li>
            <li><Link to="/compliance-framework" className="hover:text-stone-950" data-testid="footer-framework">Compliance Framework</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-stone-500 mb-4">For guests</div>
          <ul className="space-y-2">
            <li><Link to="/gdpr" className="hover:text-stone-950" data-testid="footer-gdpr">Your GDPR rights</Link></li>
            <li><Link to="/appeal" className="hover:text-stone-950" data-testid="footer-appeal">Appeal a record</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-stone-500 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} GuestIntel · Know Ahead.</div>
          <div className="flex items-center gap-3">
            <a href="mailto:contact@guestintel.net" className="hover:text-stone-950">contact@guestintel.net</a>
            <span>·</span>
            <a href="mailto:trust@guestintel.net" className="hover:text-stone-950">trust@guestintel.net</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
